/**
 * MSAL Redirect Handler Component - Simplified Version
 * 
 * This component simply renders children immediately.
 * MSAL redirect handling happens in index.tsx BEFORE React renders.
 */

import React from 'react';

interface MsalRedirectHandlerProps {
  children: React.ReactNode;
}

export const MsalRedirectHandler = ({ children }: MsalRedirectHandlerProps) => {
  // MSAL is handled before React app starts (in index.tsx)
  // This component just passes through children
  return <>{children}</>;
};
